import $ from "jquery";

const formTabs = document.getElementsByClassName('customer-form__inputs');
const nextButton = document.querySelector('.next-button');
const previousButton = document.querySelector('.prev-button');

let currentTab = 0;
$(document).ready(function () {

  if ($('#form').hasClass('customer-form')) {

    function showTab(tab) {
      formTabs[tab].style.display = 'block';
      currentTab = tab;
    }

    showTab(currentTab);

    nextButton.addEventListener('click', () => {
      formTabs[currentTab].style.display = 'none';
      showTab(1);
    });

    previousButton.addEventListener('click', () => {
      formTabs[currentTab].style.display = 'none';
      showTab(0);
    });

    document.addEventListener('wpcf7invalid', (event) => {
      console.log('Test');
    }, false);
  }
})

